// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__22Wqx","topBottomGutter":"Layout_topBottomGutter__1OaYg"};